import { Component, OnInit, OnChanges, SimpleChanges, Input, Output, EventEmitter, OnDestroy } from "@angular/core";
import { ActivatedRoute, NavigationStart, Router } from "@angular/router";
import * as languageLibrary from '../../../../services/language'
import { Subject, Subscription } from 'rxjs';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';

import { MessageService } from "../../../../services/message.service";
import { MasterService } from "../../../../services/master.service";
import { StoreService } from "../../../../services/store.service";
import { SecurityService } from '../../../../services/security.service'
import { Contact } from "src/app/models/contact.model";
import { Identification } from "src/app/models/identification.model";
import { Communication } from "src/app/models/communication.model";
import { Address } from "src/app/models/address.model";
import { buyerIcon, identIcon } from 'src/app/utils/icons'
import { ago } from "src/app/utils/date";
import { BuyerType } from "src/app/models/buyer-type.model";
import { SEARCH_DEBOUNCE_MILLIS } from "src/app/constants/list";

@Component({
    selector: "buyer",
    templateUrl: "./buyer.component.html",
    styleUrls: ["./buyer.component.scss"],
    standalone: false
})
export class DealBuyerComponent implements OnInit, OnChanges, OnDestroy {

    @Input() language

    @Input() isUnLock: boolean = true

    @Input() saleId: number = 0
    
    protected words = languageLibrary.language
    
    protected loading: boolean = false

    protected saleBuyer: any = null
    
    protected saleCoBuyers: any[] = []
    
    protected saleCoSigners: any[] = []
    
    protected lotId: number
    
    protected buyerRole: any = null

    /** The contact chosen or created in the contact add modal. */
    private selectedContact: Object | null = null
    
    protected editBuyerId: number = 0
    
    protected deleteBuyerId: number = 0

    protected BUYER_ROLE: { id: 0; name: null }
    
    protected COBUYER_ROLE: { id: 0; name: null }
    
    protected COSIGNER_ROLE: { id: 0; name: null }

    protected buyerTypes: BuyerType[] = []

    protected buyerEdit: FormGroup

    protected findBuyer: FormGroup

    protected matchedBuyers: Contact[] = []

    protected finding: boolean = false

    // A debounce timer for search events. Used to wait for 
    // the user to stop typing before we fetch.
    private watcher: ReturnType<typeof setTimeout> = null

    protected displayContactSelector: boolean = false

    /** Listen for component events and make decisions. */
    private componentWatcher: Subscription | null = null

    private subscriptions: Subscription[] = []

    constructor(private route: ActivatedRoute, private router: Router, private ms: MessageService, private master: MasterService, private store: StoreService, public security: SecurityService, private fb: FormBuilder) {
        this.buyerEdit = this.fb.group({
            saleBuyerTypeId: new FormControl<number>(1, [])
        })

        this.findBuyer = this.fb.group({
            inquiry: new FormControl<string>('', [])
        })
    }

    ngOnInit(): void {
        this.saleId = 0
        const id = parseInt(this.route.snapshot.params['id'])
        if (id && !isNaN(id) && (id > 0)) {
            this.saleId = id
        }
        
        this.lotId = parseInt(localStorage.getItem('lot'))

        this.fetchRoles()
        this.fetchBuyerTypes()

        this.subscriptions.push(
            this.buyerEdit.get('saleBuyerTypeId').valueChanges.subscribe((typeId) => {
                if (!this.saleBuyer) {
                    return
                }

                if (!this.isUnLock) {
                    return
                }

                const type = this.buyerTypes.find((item) => item.id == typeId)
                if (!type) {
                    return
                }

                this.saleBuyer.saleBuyerTypeId = type.id
                this.saleBuyer.buyerType = type.name
                this.saleBuyer.buyerTypeCode = type.code
                this.modifySaleBuyer(this.saleBuyer)
            })
        )

        this.subscriptions.push(
            this.findBuyer.get('inquiry').valueChanges.subscribe(inquiry => {
                if (this.watcher) {
                    clearTimeout(this.watcher)
                    this.watcher = null
                }

            const found = this.matchedBuyers.find((buyer) => `${buyer.name} ${buyer.city}, ${buyer.state}` === inquiry)
            if (found) {
                this.buyerRole = this.BUYER_ROLE
                this.contactSelected(found.id)
                return
            }

            this.watcher = setTimeout(() => {
                this.findABuyer()
            }, SEARCH_DEBOUNCE_MILLIS)
        })
    )

    this.componentWatcher = this.ms.channelComponents$.subscribe((event) => {
            if (!event || !event.message) {
                return
            }

            switch (event.message) {
                case 'saleCreated':
                    this.saleCreated(event.value)
                    break
            }
        })
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!changes) {
            return
        }

        const first = Object.values(changes).some(c => c.isFirstChange())
        if (first) {
            return
        }

        if (changes.isUnLock) {
            this.buyerEdit.get('saleBuyerTypeId').disable({emitEvent: false})
            if (this.isUnLock) {
                this.buyerEdit.get('saleBuyerTypeId').enable({emitEvent: false})
            }
        }
    }

    ngOnDestroy() {
        for (const sub of this.subscriptions) {
            sub.unsubscribe()
        }
        if (this.componentWatcher) {
            this.componentWatcher.unsubscribe()
        }
        if (this.watcher) {
            clearTimeout(this.watcher)
        }
    }

    // todo: listener to childrens
    public listenEndpoint = (e) => {
        switch (e.message) {
            case 'reloadContactDetail':
                break
            case 'buyerAddressSelected':
                const btn = (document.getElementById('btn-select-address-buyer-modal') as HTMLButtonElement)
                if (btn) {
                    btn.click()
                }
                
                const addressId: number = parseInt(e.id)
                if (!e.id || isNaN(addressId) || (addressId <= 0)) {
                    return
                }

                this.saveSaleBuyerAddress(addressId)
                break
        }
    }

    /**
     * Acquire the buyer role objects from the db
     */
    private fetchRoles = async () => {
        this.loading = true

        return this.master.getAsync(`sales/buyerroles`).then(res => {
            this.loading = false
            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            if (!res || !res.data) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (!res.data.roles) return

            this.BUYER_ROLE = res.data.roles.find(el => el['name'].toLowerCase() === 'buyer')
            this.COBUYER_ROLE = res.data.roles.find(el => el['name'].toLowerCase() === 'co-buyer')
            this.COSIGNER_ROLE = res.data.roles.find(el => el['name'].toLowerCase() === 'cosigner')
            this.fetchBuyers()
        })
    }

    /** */
    private fetchBuyerTypes = () => {
        if (this.buyerTypes && (this.buyerTypes.length > 0)) {
            return
        }

        this.master.get(`collections/sales/buyertypes`, res => {
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] });
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error });
            }

            if (!res.data.BuyerTypes) {
                return;
            }

            this.buyerTypes = res.data.BuyerTypes;
        })
    }

    /**
     * Acquire the contacts assigned to the sale from the db
     */
    public fetchBuyers = async () => {
        if (this.saleId <= 0) {
            return
        }

        this.loading = true
        
        const buyers: Array<Object> = await this.master.getAsync(`sales/${this.saleId}/buyers`).then(res => {
            this.loading = false
            
            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return null
            }

            if (!res || !res.data) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return null
            }

            if (!res.data) {
                return null
            }

            return res.data
        })

        if (!buyers || (buyers.length <= 0)) {
            return
        }

        const buyer = buyers.find(el => el['saleBuyerRoleId'] == this.BUYER_ROLE['id'])
        if (buyer) {
            this.saleBuyer = this.flattenBuyer(buyer)
            this.buyerEdit.get('saleBuyerTypeId').setValue(this.saleBuyer.saleBuyerTypeId, {emitEvent: false})
            
            const payload = {
                id: parseInt(this.saleBuyer['id']), 
                name: `${this.saleBuyer['lastName']}, ${this.saleBuyer['firstName']}`,
                type: this.saleBuyer.buyerType,
                zip: this.saleBuyer['zipCode']
            }

            this.ms.channelComponents$.emit({message: 'buyerRead', section: 'buyer', value: payload})
        }

        const coBuyers = buyers.filter((item) => item['saleBuyerRoleId'] == this.COBUYER_ROLE['id']) || []
        for (let coBuyer of coBuyers) {
            this.saleCoBuyers.push(this.flattenBuyer(coBuyer))
        }

        const coSigners = buyers.filter((item) => item['saleBuyerRoleId'] == this.COSIGNER_ROLE['id']) || []
        for (let coSigner of coSigners) {
            this.saleCoSigners.push(this.flattenBuyer(coSigner))
        }
    }

    /**
     * 
     * @param buyer 
     * @returns 
     */
    private flattenBuyer = (buyer: Object): Object => {
        if (!buyer || !buyer['contact']) {
            return null
        }

        const contact: Contact = JSON.parse(JSON.stringify(buyer['contact']))
        delete(buyer['contact'])

        const chosenAddress: Address = buyer['contactAddress']
        const primaryEmail: Communication = contact['contactCommunications'].find(el => el.type === 'email' && el.primary == true)
        const primaryPhone: Communication = contact['contactCommunications'].find(el => el.type === 'phone' && el.primary == true && el.subtype === 'cell') || 
            contact['contactCommunications'].find(el => el.type === 'phone' && el.primary == true && el.subtype === 'home') || 
            contact['contactCommunications'].find(el => el.type === 'phone' && el.primary == true && el.subtype === 'work')
        const primaryIdentification: Identification = contact['contactIdentifications'].find(el => el.primary == true)
        
        const res = {
            id: parseInt(buyer['id']),
            saleId: this.saleId,
            lotId: this.lotId,
            contactId: contact.id,
            addressId: chosenAddress.id,
            isIndividual: contact['isIndividual'] ? (contact['isIndividual'] == true) : false, 
            saleBuyerRole: this.buyerRole,
            saleBuyerRoleId: parseInt(buyer['saleBuyerRoleId']),
            saleBuyerTypeId: parseInt(buyer['saleBuyerTypeId']),
            buyerType: buyer['saleBuyerType']['name'],
            buyerTypeCode: buyer['saleBuyerType']['code'],
            companyName: contact['companyName'],
            firstName: contact['firstName'],
            lastName: contact['lastName'],
            address: chosenAddress.address,
            address2: chosenAddress.address2,
            city: chosenAddress.city,
            state: chosenAddress.state,
            zipCode: chosenAddress.zipCode,
            county: chosenAddress.county,
            country: chosenAddress.country,
            email: primaryEmail ? primaryEmail.value : '',
            phoneNumber: primaryPhone ? primaryPhone.value : '',
            phoneType: primaryPhone ? primaryPhone.subtype : '',
            identificationNumber: primaryIdentification ? primaryIdentification.number: null,
            identificationIssuer: primaryIdentification ? primaryIdentification.issuer: null,
            identificationType: primaryIdentification ? primaryIdentification.identificationType.type: null,
            identificationExpiration: primaryIdentification ? primaryIdentification.expirationDate: null
        }

        return res
    }

    /**
     * Acquire buyer list by given search inquiry
     */
    public findABuyer = (): void => {
        if (this.security.notPermitted('contacts', 'contact list', 'view')) {
            return
        }

        if (this.finding) { // already getting next page
            return
        }

        this.matchedBuyers = []
        const inquiry = this.findBuyer.get('inquiry').value
        if (!inquiry || (inquiry.length <= 0)) {
            return
        }

        const inquiryParam = `&q=${encodeURIComponent(inquiry)}`
        this.finding = true

        let notSaleParam = ''
        if (this.saleId && (this.saleId > 0)) {
            notSaleParam = `&notSaleId=${this.saleId}`
        }

        this.master.get(`contacts?page=1${inquiryParam}${notSaleParam}`, (res) => {
            this.finding = false

            if (!res || !res.data) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] });
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error });
                return
            }

            this.matchedBuyers = res.data.contacts;
        })
    }

    /**
     * Assign the selected contact role based on which add button was clicked
     * @param { Object } paramBuyerRole The role object of the selected contact.
     */
    public selectContact = (e: Event, paramBuyerRole: Object) => {
        e.preventDefault()
        e.stopPropagation()
        this.buyerRole = paramBuyerRole

        this.displayContactSelector = true
        const btn = (document.getElementById('btn-select-contact') as HTMLButtonElement)
        if (!btn) {
            return
        }

        btn.click()
    }

    /**
     * Assign the selected contact and map the fields 
     * @param { Object } paramBuyerRole The role object of the selected contact.
     */
    public contactSelected = async (contactId) => {
        const id = parseInt(contactId)
        if (!id || isNaN(id) || (id <= 0)) {
            return
        }

        await this.buildContact(contactId).then(res => {
            this.selectedContact = res
        })

        this.saveSaleBuyer()

        this.displayContactSelector = false
        const btn = (document.getElementById('btn-close-modal-contact-list') as HTMLButtonElement)
        if (!btn) {
            return
        }

        btn.click()
    }

    /** Handle close events of the contact selector modal. */
    public contactSelectorClosed = (e) => {
        this.displayContactSelector = false
    }

    /**
     * Build the contact data from the contact db with default primary data
     * @param { Number } id The id of the contact to build.
     * @returns { Promise<Object> } The contact object
     */
    private buildContact = async (id: number): Promise<Object> => {
        const contact: Contact = await this.lookupContact(id)
        return this.flattenContact(contact)
    }

    /**
     * 
     * @param contact 
     * @returns 
     */
    private flattenContact = (contact: Contact): Object => {
        if (!contact || !contact['contactAddresses'] || !contact['contactCommunications']) {
            return null
        }

        const primaryAddress = contact['contactAddresses'].find(el => el.primaryAddress == true)
        const primaryEmail = contact['contactCommunications'].find(el => el.type === 'email' && el.primary == true)
        const primaryPhone = contact['contactCommunications'].find(el => el.type === 'phone' && el.primary == true && el.subtype === 'cell') || 
            contact['contactCommunications'].find(el => el.type === 'phone' && el.primary == true && el.subtype === 'home') || 
            contact['contactCommunications'].find(el => el.type === 'phone' && el.primary == true && el.subtype === 'work')
        const primaryIdentification = contact['contactIdentifications'] ? contact['contactIdentifications'].find(el => el.primary == 1) : null
        
        const res = {
            saleId: this.saleId,
            lotId: this.lotId,
            saleBuyerRole: this.buyerRole,
            saleBuyerRoleId: parseInt(this.buyerRole['id']),
            saleBuyerTypeId: contact.isIndividual ? 1 : 2, // 1 = Individual, 2 = Business
            buyerType: contact.isIndividual ? 'Individual' : 'Business',
            buyerTypeCode: contact.isIndividual ? 'IN' : 'BS',
            contactId: contact['id'],
            addressId: primaryAddress.id,
            companyName: contact['companyName'],
            firstName: contact['firstName'],
            lastName: contact['lastName'],
            address: primaryAddress.address,
            address2: primaryAddress.address2,
            city: primaryAddress.city,
            state: primaryAddress.state,
            zipCode: primaryAddress.zipCode,
            county: primaryAddress.county,
            country: primaryAddress.country,
            email: primaryEmail ? primaryEmail.value : '',
            phoneNumber: primaryPhone ? primaryPhone.value : '',
            phoneType: primaryPhone ? primaryPhone.subtype : '',
            identificationNumber: primaryIdentification ? primaryIdentification.number: '',
            identificationIssuer: primaryIdentification ? primaryIdentification.issuer: '',
            identificationType: primaryIdentification ? primaryIdentification.type: '',
            identificationExpiration: primaryIdentification ? primaryIdentification.expirationDate: ''
        }

        return res
    }

    /**
     * Acquire the contact details from the db
     * @param { Number } id The id of the contact to lookup.
     * @returns { Promise<Object> } The contact object
     */
    private lookupContact = async (id: number): Promise<Contact> => {
        if (id <= 0) {
            return null
        }

        return await this.master.getAsync(`contacts/${id}`).then((res) => {
            this.loading = false

            if (!res || !res.data) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
            }

            return res.data.contact
        })
    }
    
    /**
     * A saleCreated event from parent, assign saleId and
     * save the buyer, if one is selected
     * @returns { Object } The contact object
     */
    public saleCreated = (saleId: number): void => {
        if (saleId <= 0) {
            return
        }
        
        if (this.saleId != saleId) {
            this.saleId = saleId
            if (this.selectedContact && (Object.keys(this.selectedContact).length > 0)) {
                this.saveSaleBuyer()
            }
        }
    }

    /**
     * 
     */
    private saveSaleBuyer = (): void => {
        if (this.saleId <= 0) {
            const payload = {
                id: 0, 
                name: null, 
                type: null, 
                zip: null
            }

            this.ms.channelComponents$.emit({message: 'buyerInit', section: 'buyer', value: payload})
            return
        }

        if (!this.selectedContact) {
            return
        }

        const buyer = {
            saleId: this.saleId,
            lotId: this.lotId,
            contactId: this.selectedContact['contactId'],
            addressId: this.selectedContact['addressId'],
            saleBuyerRoleId: this.selectedContact['saleBuyerRole']['id'],
            saleBuyerTypeId: this.selectedContact['saleBuyerTypeId']
        }

        return this.master.post(`sales/${this.saleId}/buyers`, { buyer: buyer }, (res) => {
            if (!res || !res.data) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            if (!res.data || !res.data.id) {
                return
            }

            this.selectedContact['id'] = res.data.id

            switch (this.buyerRole['id']) {
                case this.BUYER_ROLE['id']:
                    this.saleBuyer = this.selectedContact

                    const payload = {
                        id: parseInt(this.saleBuyer['id']), 
                        name: `${this.saleBuyer['lastName']}, ${this.saleBuyer['firstName']}`, 
                        type: this.saleBuyer['buyerType'],
                        zip: this.saleBuyer['zipCode']
                    }

                    this.ms.channelComponents$.emit({message: 'buyerAdded', section: 'buyer', value: payload})
                    break
                case this.COBUYER_ROLE['id']:
                    this.saleCoBuyers.push(this.selectedContact)
                    this.ms.channelComponents$.emit({message: 'coBuyerChanged', section: 'buyer', value: buyer})
                    break
                case this.COSIGNER_ROLE['id']:
                    this.saleCoSigners.push(this.selectedContact)
                    this.ms.channelComponents$.emit({message: 'coBuyerChanged', section: 'buyer', value: buyer})
                    break
            }
        })
    }

    /**
     * 
     * @param buyer 
     */
    private modifySaleBuyer = (buyer) => {
        if (!buyer || !buyer.id) {
            return
        }

        const payload = {
            addressId: buyer['addressId'],
            saleBuyerRoleId: buyer['saleBuyerRoleId'],
            saleBuyerTypeId: buyer['saleBuyerTypeId']
        }

        return this.master.put(`sales/${this.saleId}/buyers/${buyer.id}`, { buyer: payload }, (res) => {
            if (!res || !res.data) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            switch (buyer['saleBuyerRoleId']) {
                case this.BUYER_ROLE['id']:
                    const payload = {
                        id: parseInt(buyer.id), 
                        name: `${buyer['lastName']}, ${buyer['firstName']}`, 
                        type: buyer['buyerType'],
                        zip: buyer['zipCode']
                    }

                    this.ms.channelComponents$.emit({message: 'buyerChanged', section: 'buyer', value: payload})
                    break
                case this.COBUYER_ROLE['id']:
                case this.COSIGNER_ROLE['id']:
                    this.ms.channelComponents$.emit({message: 'coBuyerChanged', section: 'buyer', value: buyer})
                    break
            }
        })
    }

    /**
     * Open the contact editor in a modal.
     * @param e Event that triggered the contact edit.
     */
    public editBuyer = (e: Event, contactId) => {
        e.stopPropagation()
        e.preventDefault()

        const identity = parseInt(contactId)
        if (!identity || isNaN(identity) || (identity <= 0) || !this.isUnLock) {
            this.editBuyerId = 0
            return
        }

        this.editBuyerId = identity

        const btn = (document.getElementById('editContactModalBtn_buyer') as HTMLButtonElement)
        if (!btn) {
            return
        }

        btn.click()
    }

    /**
     * Assigns the selected contactId to variable 
     * to be used in modals
     * @param { Number } contactId The id of the sale buyer
     */
    public chooseAddress = (e: Event, contactId) => {
        e.stopPropagation()
        e.preventDefault()

        if (!this.isUnLock) {
            return
        }

        const identity = parseInt(contactId)
        if (!identity || isNaN(identity) || (identity <= 0) || !this.isUnLock) {
            this.editBuyerId = 0
            return
        }

        this.editBuyerId = identity

        const btn = (document.getElementById('btn-select-address-buyer-modal') as HTMLButtonElement)
        if (btn) {
            btn.click()
        }
    }

    /**
     * Links a newly selected sale buyer address to the existing sale.
     */
    private saveSaleBuyerAddress = (id: number): void => {
        if (this.saleId <= 0) {
            return
        }

        if (!id || (id <= 0)) {
            return
        }

        if (!this.saleBuyer || (!this.saleBuyer['id'])) {
            return
        }

        const payload = {
            buyer: {
                addressId: id
            }
        }

        return this.master.patch(`sales/${this.saleId}/buyers/${this.saleBuyer['id']}`, payload, (res) => {
            if (!res || !res.data) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            this.saleBuyer = null
            this.saleCoBuyers = []
            this.saleCoSigners = []

            this.fetchBuyers()
        })
    }

    /**
     * Handle delete buyer dialog accept event.
     * @returns 
     */
    public proceedWithDiscard = async () => {
        if (!this.deleteBuyerId || (this.deleteBuyerId <= 0)) {
            return
        }

        await this.discard(this.deleteBuyerId)
    }

    /**
     * Performs the delete request to the api,
     * updates UI buyer data, and removes the id
     * from the contactList filter.
     */
    private discard = async (buyerId: number) => {
        if (buyerId <= 0) {
            return
        }

        if (this.saleId <= 0) {
            return
        }

        this.loading = true
            
        await this.master.discard(`sales/${this.saleId}/buyers/${buyerId}`, (res) => {
            this.deleteBuyerId = 0
            this.loading = false

            if (!res || !res.data) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }    

            if (this.saleBuyer && buyerId == this.saleBuyer['id']) {
                this.saleBuyer = null
                const payload = {
                    id: 0, 
                    name: null, 
                    type: null, 
                    zip: null
                }

                this.ms.channelComponents$.emit({message: 'buyerDiscarded', section: 'buyer', value: payload})
                return
            }

            if (this.saleCoBuyers && this.saleCoBuyers.length > 0) {
                const found = this.saleCoBuyers.find(item => { return item['id'] == buyerId })

                if (found && found.id) {
                    this.saleCoBuyers = this.saleCoBuyers.filter(item => { return item['id'] != buyerId })
                    this.ms.channelComponents$.emit({message: 'coBuyerDiscarded', section: 'buyer', value: buyerId})
                    return
                }
            }

            if (this.saleCoSigners && this.saleCoSigners.length > 0) {
                const found = this.saleCoSigners.find(item => { return item['id'] == buyerId })

                if (found && found.id) {
                    this.saleCoSigners = this.saleCoSigners.filter(item => { return item['id'] != buyerId })
                    this.ms.channelComponents$.emit({message: 'coBuyerDiscarded', section: 'buyer', value: buyerId})
                    return
                }
            }
        })
    }

    public contactModified = (contact: Object) => {
        this.fetchBuyers()
    }

    /**
     * Given a buyer type return a material icon to display.
     * @param type A buyer type to map to an icon.
     */
    protected buyerIcon = (type: string): string => {
        return buyerIcon(type)
    }

    /**
     * Given an identification type identity return a material icon to display.
     * @param type An identification type to map to an icon.
     */
    protected identIcon = (typeId: number): string => {
        return identIcon(typeId)
    }

    /**
     * 
     * @param due 
     * @returns 
     */
    public expiryToClass = (due: string): string => {
        const key = ago(due)
        if (!key || (key.length <= 0)) {
            return 'secondary'
        }

        switch (key.toLocaleLowerCase()) {
            case 'past':
                return 'danger'
            case 'soon':
            case 'today':
                return 'warning'
            default:
                return 'secondary'
        }
    }
}
